export function isEmpty (data: any) {
  if (
    data === '' ||
    data === null ||
    data === undefined ||
    JSON.stringify(data) === undefined ||
    JSON.stringify(data) === '[]' ||
    JSON.stringify(data) === '{}'
  ) return true;
  return false;
}

export function isPositiveInteger (str: number | string) {
  const reg = /(^[1-9]\d*$)/
  try { 
    return reg.test(String(str))
  } catch (e) {
    return false
  }
}

// 组包含某个子元素
export function hasChild (child: string, list: Array<string>) {
  return list.indexOf(child) > -1
}
// 组包含所有的子元素集合
export function hasAllChildren (children: Array<string>, list: Array<string>) {
  for (let i = 0; i < children.length; i++) {
    if (list.indexOf(children[i]) === -1) {
      return false
    } 
  }
  return true
}
// 组包含的子元素集合种的任一
export function hasAnyChildren (children: Array<string>, list: Array<string>) {
  for (let i = 0; i < children.length; i++) {
    if (list.indexOf(children[i]) > -1) {
      return true
    } 
  }
  return false
}
